import { FC, ReactNode } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface ModalComponentProps {
  isOpen: boolean;
  toggle: () => void;
  children: ReactNode;
  description: string;
  header: string;
  scrollable?: boolean;
}

const ModalComponent: FC<ModalComponentProps> = ({
  isOpen,
  toggle,
  children,
  header,
  description,
  scrollable,
}) => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  return (
    <Modal
      scrollable={scrollable}
      isOpen={isOpen}
      toggle={toggle}
      style={isMobile ? { margin: 23 } : {}}
    >
      <ModalHeader toggle={toggle} tag="h4">
        {header}
      </ModalHeader>
      <ModalBody>
        {description}
        {children}
      </ModalBody>
    </Modal>
  );
};

export default ModalComponent;
